'use strict'
import moment from 'moment'

const infoStampante = function(risposta) {
  if (!risposta || risposta.errori) {
    return {
      matricola: '--',
      data: '--',
      firmware: '--',
      liberoDGFE: '--',
      modo: '--',
      stato: '--',
      lastZ: '--',
      lastDocF: '--',
      errore: risposta.errori ? `${risposta.errori.message.error}: ${risposta.errori.message.description}` : 'Errore',
      errCode: risposta.errori ? risposta.errori.message.code : '',
      filePendenti: '--',
      oldFile: '',
      lowDGFE: false,
      ipStampante: ''
    }
  } else {
    return {
      matricola: risposta.matricola,
      data: risposta.data,
      firmware: 'FW v.' + risposta.firmware,
      liberoDGFE: '', // `${100 - risposta.dgfeStatus.usePerc}%`,
      modo: risposta.altriStati.modo,
      stato: risposta.statoRT,
      lastZ: risposta.azzeramentoDaInviare,
      lastDocF: risposta.altriStati.ultimoScontrinoEmesso,
      errore: '',
      errCode: '',
      filePendenti: `${risposta.filePendenti} / ${'---'}`,
      oldFile: '',
      lowDGFE: '', // risposta.dgfeStatus.usePerc > 90,
      ipStampante: risposta.ipStampante
    }
  }
}

const mostraAggiornaOra = function(risposta) {
  if (risposta && risposta.getDate) {
    const diff = moment().diff(moment(risposta.getDate.isoDate), 'm')
    return Math.abs(diff) > 2
  }
  return false
}

const mostraCambioStato = function(risposta) {
  // Verificare: deve segnalare se non è stata effettuata la chiusura
  return false
}

const mostraCambioModo = function(risposta) {
  // verificare: Deve segnalare se non è in stato registrazione
  return risposta && risposta.modo !== 'Chiave REG'
}

const passaModoReg = function() {

}

const aggiornaOraPossibile = function(infoStampante) {
  return infoStampante.rtStatus.dayOpened === 0
}

export default {
  infoStampante,
  mostraAggiornaOra,
  mostraCambioStato,
  mostraCambioModo,
  passaModoReg,
  aggiornaOraPossibile
}
